import React from 'react';
import './ComingSoon.css';

const Settings = () => {
  return (
    <div className="coming-soon-page">
      <div className="coming-soon-container">
        <div className="coming-soon-icon">⚙️</div>
        <h1>Configurações da Loja</h1>
        <p>Esta funcionalidade estará disponível em breve.</p>
        
        <div className="features-preview">
          <h3>Funcionalidades planejadas:</h3>
          <ul>
            <li>Configurar microfones da loja</li>
            <li>Gerenciar vendedores</li>
            <li>Definir horários de funcionamento</li>
            <li>Configurar notificações</li>
            <li>Relatórios personalizados</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Settings;